import _createForOfIteratorHelper from "/app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { __decorate } from "tslib";
import { Vue, Options } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import HeaderTable from '@/components/platform/copySpeach/HeaderTable.vue';
import TitleCell from '@/components/platform/copySpeach/TitleCell.vue';
import store from '@/store';
import { SET_AUTHOR, SET_CATEGORY } from '@/store/actions/speach';
import SearchUser from '@/components/platform/copySpeach/SearchUser.vue';
import SelectCategory from '@/components/platform/copySpeach/SelectCategory.vue';
var SpeachConfigureTable = /*#__PURE__*/function (_Vue) {
  function SpeachConfigureTable() {
    var _this;
    _classCallCheck(this, SpeachConfigureTable);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SpeachConfigureTable, [].concat(args));
    _defineProperty(_this, "destinationPlatform", void 0);
    _defineProperty(_this, "listSpeach", void 0);
    _defineProperty(_this, "tableRef", 'speach-configure-table');
    _defineProperty(_this, "checkedRows", []);
    _defineProperty(_this, "numberOfSpeachesChecked", 0);
    _defineProperty(_this, "authorActionBar", null);
    _defineProperty(_this, "categoryActionBar", null);
    return _this;
  }
  _inherits(SpeachConfigureTable, _Vue);
  return _createClass(SpeachConfigureTable, [{
    key: "mounted",
    value: function mounted() {}
    // -- CUSTOM FUNCTIONS
  }, {
    key: "updateCheckedRows",
    value: function updateCheckedRows(checkedList) {
      this.numberOfSpeachesChecked = checkedList.length;
      this.checkedRows = checkedList;
    }
  }, {
    key: "changeAuthor",
    value: function changeAuthor(userCopy, cour) {
      store.dispatch(SET_AUTHOR, {
        cour: cour,
        userCopy: userCopy
      });
      // We need to force refresh of the checkbox context when we update the author in the speachs list in the store.
      this.refreshCheckedRowsState();
    }
  }, {
    key: "changeCategory",
    value: function changeCategory(category, cour) {
      store.dispatch(SET_CATEGORY, {
        cour: cour,
        category: category
      });
      // We need to force refresh of the checkbox context when we update the category in the speachs list in the store.
      this.refreshCheckedRowsState();
    }
  }, {
    key: "refreshCheckedRowsState",
    value: function refreshCheckedRowsState() {
      var _this2 = this;
      var speachTableRef = this.$refs[this.tableRef];
      this.$nextTick(function () {
        var _this2$checkedRows;
        (_this2$checkedRows = _this2.checkedRows) === null || _this2$checkedRows === void 0 || _this2$checkedRows.forEach(function (cr) {
          speachTableRef.toggleRowSelection(cr, true);
        });
      });
    }
  }, {
    key: "changeAuthorActionBar",
    value: function changeAuthorActionBar(userCopy) {
      this.authorActionBar = userCopy;
    }
  }, {
    key: "changeCategoryActionBar",
    value: function changeCategoryActionBar(category) {
      this.categoryActionBar = category;
    }
  }, {
    key: "visibilityChanged",
    value: function visibilityChanged(isVisible, row) {
      if (isVisible && !(row !== null && row !== void 0 && row.title)) {
        this.$emit('empty-cour-visible', row);
      }
    }
  }, {
    key: "cancelActionBar",
    value: function cancelActionBar() {
      this.resetCheckedSpeach();
    }
  }, {
    key: "confirmActionBar",
    value: function confirmActionBar() {
      var _iterator = _createForOfIteratorHelper(this.checkedRows),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var cour = _step.value;
          if (this.authorActionBar) {
            store.dispatch(SET_AUTHOR, {
              cour: cour,
              userCopy: this.authorActionBar
            });
          }
          if (this.categoryActionBar) {
            store.dispatch(SET_CATEGORY, {
              cour: cour,
              category: this.categoryActionBar
            });
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.resetCheckedSpeach();
    }
  }, {
    key: "resetCheckedSpeach",
    value: function resetCheckedSpeach() {
      this.authorActionBar = null;
      this.categoryActionBar = null;
      this.checkedRows = [];
      this.numberOfSpeachesChecked = 0;
      var speachTableRef = this.$refs[this.tableRef];
      speachTableRef === null || speachTableRef === void 0 || speachTableRef.clearSelection();
    }
  }]);
}(Vue);
__decorate([Prop({
  default: ''
})], SpeachConfigureTable.prototype, "destinationPlatform", void 0);
__decorate([Prop({
  default: []
})], SpeachConfigureTable.prototype, "listSpeach", void 0);
SpeachConfigureTable = __decorate([Options({
  components: {
    SelectCategory: SelectCategory,
    SearchUser: SearchUser,
    HeaderTable: HeaderTable,
    TitleCell: TitleCell
  }
})], SpeachConfigureTable);
export default SpeachConfigureTable;